import { render, staticRenderFns } from "./LessonsPricesForm.vue?vue&type=template&id=7b603a76&"
import script from "./LessonsPricesForm.vue?vue&type=script&lang=js&"
export * from "./LessonsPricesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports